import React from 'react'
import { cn } from '../../../../utils/classnames'

const ClientSwitchTabs = ({ options, value, onChange }) => {
  const isFirstActive = value === options[0]?.value

  const getInactiveBorders = (index) => {
    if (value === options[index]?.value) return '' // botão ativo, sem borda

    if (index === 0) return 'border-l border-t border-b'
    if (index === 1) {
      return isFirstActive
        ? 'border-r border-t border-b'
        : 'border-l border-t border-b'
    }
    if (index === 2) return 'border-r border-t border-b'

    return ''
  }

  return (
    <div className="inline-flex overflow-hidden">
      {options.map((option, index) => {
        const isActive = value === option.value

        return (
          <button
            key={option.value}
            onClick={() => onChange(option.value)}
            className={cn(
              'px-5 py-2 text-xs font-semibold uppercase transition-colors whitespace-nowrap border-bluePale',
              isActive
                ? 'bg-tealMedium text-white'
                : `bg-tealSnow text-blueDeep hover:bg-blueSoft ${getInactiveBorders(index)}`,
              index === 0 && 'rounded-l-full',
              index === 2 && 'rounded-r-full'
            )}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}

export default ClientSwitchTabs
